import React, { useEffect } from "react";
import { useState } from "react";
import { Card, Form, Row, Col, Image } from "react-bootstrap";
import { usePlannerContext } from "../../../contexts/planner.contexts";
import { getMonthlyPayment } from "../../../services/helperService";

import Images from "../../CRMs/crm2.0";
import userService from "../../../services/UserService";

const TspOptionForm = ({ submit }) => {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [isSubmitted, setSubmit] = useState(false);
  const { plannerData, setOnChangeStatus } = usePlannerContext();
  const [formData, setformData] = useState({});
  const [monthlyPayment, setMonthlyPayment] = useState();

  useEffect(() => {
    if (
      plannerData &&
      typeof plannerData === "object" &&
      Object.keys(plannerData).length > 0
    ) {
      const data = getMonthlyPayment(
        plannerData.tsp_opt_amount ? plannerData.tsp_opt_amount : 100000,
        plannerData["MRA"]
      );

      if (plannerData["family_status"] == "married") {
        setOpen(true);
      }
      if (
        plannerData["family_status"] == "single" ||
        plannerData["family_status"] == "divorced"
      ) {
        setShow(true);
      }
      setMonthlyPayment(data);
      setformData(plannerData);
    }
  }, [plannerData]);
  const SubmitForm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSubmit(true);

    if (userService.getAccess().bpg_skip_req == 1) {
      submit(e, formData);
    } else if (formData["lifeAnnuity"]) {
      setSubmit(false);
      submit(e, formData);
    }
  };

  const handleOpenSingleLife = (event) => {
    setShow(!show);
  };

  const handleOpenJointLife = (event) => {
    setOpen(!open);
  };

  useEffect(() => {
    const value = formData.tsp_opt_amount;
    if (formData.tsp_opt_amount) {
      const payment = getMonthlyPayment(value, formData["MRA"]);
      setMonthlyPayment(payment);
    }
  }, [formData.tsp_opt_amount]);

  const handleTSPAmount = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const payment = getMonthlyPayment(value, formData["MRA"]);
    setMonthlyPayment(payment);
    handleStateByField(name, value);
  };
  const handleStateByField = (name, value) => {
    setOnChangeStatus(true);

    setformData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <>
      <Card.Body className="Tsp-withdraw-opt">
        <Form name="esForm" onSubmit={SubmitForm} className="Tsp-withdraw-form">
          <div style={{ textAlign: "center" }}>
            <div className="head-title">TSP Withdrawal Options</div>
          </div>

          <div className="Tsp-red-box mt-2">
            <div
              className="display-icon"
              onClick={() =>
                handleStateByField("lifeAnnuity", "tsp_opt_full_or_partial_wid")
              }
            >
              {formData["lifeAnnuity"] == "tsp_opt_full_or_partial_wid" ? (
                <i className="fa-solid fa-square-check  px-2 fa-lg"></i>
              ) : (
                <i
                  className={`fa-solid fa-square px-2 fa-lg ${
                    formData["lifeAnnuity"] && "icon-gray"
                  }`}
                ></i>
              )}
              Full or Partial Withdrawal:
            </div>
          </div>
          <div className="Tsp-sub-red-box Tsp-Text">
            Full or Partial Withdrawal allows you to withdraw your entire
            account at one time or over a series of payments spread over time.
          </div>

          <div className="Tsp-red-box mt-3">
            <div
              className="display-icon"
              onClick={() =>
                handleStateByField("lifeAnnuity", "tsp_opt_tsp_monthly_pay")
              }
            >
              {formData["lifeAnnuity"] == "tsp_opt_tsp_monthly_pay" ? (
                <i className="fa-solid fa-square-check px-2 fa-lg"></i>
              ) : (
                <i
                  className={`fa-solid fa-square px-2 fa-lg ${
                    formData["lifeAnnuity"] && "icon-gray"
                  }`}
                ></i>
              )}
              TSP Periodic Payments:
            </div>
          </div>
          <div className="Tsp-sub-red-box Tsp-Text">
            With the PERIODIC PAYMENT option, you have the ability to take the
            systematic monthly, quarterly, or annual payments. You take the risk
            that you may outlive your money. Your payments will end when the
            money in your account runs out. However, you have the flexibility to
            change your payment amount when you desire. Since the balance in
            your TSP, which has not yet been paid to you, remains in your
            account, you can continue to invest in any TSP funds you choose.
          </div>
          <div className="Tsp-red-box text-flex mt-3">
            <div
              className="display-icon"
              onClick={() =>
                handleStateByField(
                  "lifeAnnuity",
                  "tsp_opt_single_life_annuity_tsp"
                )
              }
            >
              {formData["lifeAnnuity"] == "tsp_opt_single_life_annuity_tsp" ? (
                <i className="fa-solid fa-square-check px-2 fa-lg"></i>
              ) : (
                <i
                  className={`fa-solid fa-square px-2 fa-lg ${
                    formData["lifeAnnuity"] && "icon-gray"
                  }`}
                ></i>
              )}
              MetLife
            </div>
          </div>
          <div className="Tsp-sub-red-box">
            <Row>
              <Col md={2}>
                <Image className="Tsp-img1" src={Images.metLifeAnnuity} />
              </Col>
              <Col md={10}>
                {" "}
                <p className="Tsp-Text">
                  The Thrift Savings Plan (TSP) offers both single life and
                  joint life annuity options through MetLife. A single life
                  annuity provides a guaranteed monthly payment for as long as
                  you live. A joint life annuity provides a guaranteed monthly
                  payment for as long as either you or your surviving spouse is
                  living.
                </p>
                <p className="Tsp-Text mt-2">
                  One important consideration of this annuity election is the{" "}
                  loss of liquidity and flexibility. Once annuitized, you no
                  longer have access to larger lump sums of your TSP balance
                  should an emergency or significant financial need arise.
                  Additionally, unless the cash refund option is elected, any
                  remaining principal is not passed on to heirs. Upon your
                  death—or upon the death of both you and your spouse if a joint
                  life annuity is elected— remaining funds are retained by
                  MetLife, rather than distributed to children or other
                  beneficiaries. The cash refund option may be elected to ensure
                  that any remaining principal is paid to your beneficiaries;
                  however, selecting either the cash refund feature or a joint
                  life annuity will reduce the amount of your guaranteed monthly
                  payment.
                </p>
              </Col>
            </Row>
          </div>
          <div className="Tsp-red-box text-flex mt-3">
            <div
              className="display-icon"
              onClick={() =>
                handleStateByField(
                  "lifeAnnuity",
                  "tsp_opt_joint_life_annuity_private_sector"
                )
              }
            >
              {formData["lifeAnnuity"] ==
              "tsp_opt_joint_life_annuity_private_sector" ? (
                <i className="fa-solid fa-square-check px-2 fa-lg"></i>
              ) : (
                <i
                  className={`fa-solid fa-square px-2 fa-lg ${
                    formData["lifeAnnuity"] && "icon-gray"
                  }`}
                ></i>
              )}
              Private Sector Rollover
            </div>
          </div>
          <div className="Tsp-sub-red-box">
            <Row>
              <Col md={2}>
                <Image className="Tsp-img1" src={Images.tspImage3} />
              </Col>
              <Col md={10}>
                {" "}
                <p className="Tsp-Text">
                  The Private Sector Rollover offers solutions that
                  significantly benefit federal employees.
                </p>
                <p className="Tsp-Text mt-2">
                  It can provide a monthly payment to you, or to you and your
                  spouse, for as long as you, or you and your spouse, are alive.
                </p>
                <p className="Tsp-Text mt-2">
                  It can provide for the ability to protect your principal and
                  take monthly, quarterly or annual payments with flexibility to
                  adjust payment amounts or frequency.
                </p>
                <p className="Tsp-Text mt-2">
                  Your account value may continue growing and some options will
                  not be subject to market losses.
                </p>
                <p className="Tsp-Text">
                  You have the flexibility of accessing larger lump sums of
                  money if you need it for an emergency situation.
                </p>
                <p className="Tsp-Text mt-2">
                  Any savings remaining, upon the death of you, or you and your
                  spouse, will be paid to your other beneficiaries after your
                  death or your spouse’s death.
                </p>
              </Col>
            </Row>
          </div>
          {!formData["lifeAnnuity"] && isSubmitted && (
            <p className="red text-center mt-4">
              Select at least one item to proceed.
            </p>
          )}
          <div className="">
            <div className="text-center mt-4">
              <button className="btn-next btn question-next" type="submit">
                CONTINUE
              </button>
            </div>
          </div>
        </Form>
      </Card.Body>
    </>
  );
};

export default TspOptionForm;
